export const ScrollToTop = () => {
    window.scrollTo(0, 0)
};
